import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Policy } from "types/generated";
import { AccessResult, hasAdminAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const useCanManagePolicy = (): ((
  policy?: Pick<Policy, "space" | "spaceDetails" | "plugin">
) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (policy?: Pick<Policy, "space" | "spaceDetails" | "plugin">) => {
      if (!policy) {
        return { result: false };
      }

      if (policy.plugin?.id) {
        return {
          result: false,
          message: `This policy is managed by the plugin "${policy.plugin.name}" and can't be edited manually.`,
        };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const hasAccess = hasAdminAccess(viewer, policy.space || policy.spaceDetails?.id);

      if (hasAccess) {
        return { result: true };
      }
      return { result: false, message: NO_ACCESS_MESSAGE };
    },

    [viewer]
  );
};

export default useCanManagePolicy;
